<template>
  <div>
    <div class="container hidden-xs">
      <b-breadcrumbs :items="breadcrumbs" />
    </div>
    <section class="container">
      <div class="row">
        <div class="col-xs-12">
          <h1>Edit regulation</h1>
          <div class="page-summary-text">
            Edit details of {{ resource.title }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <h2>Details</h2>
          <label for="title">Title</label>
          <label
            v-if="$v.resource.title.$error && !$v.resource.title.required"
            class="label error pull-right"
            >Required</label
          >
          <textarea
            v-model="resource.title"
            :class="{ error: $v.resource.title.$error }"
            type="text"
            name="title"
            class="form-control"
            placeholder="Title"
            cols="2"
          />
          <label for="content">Content</label>
          <label
            v-if="$v.resource.body.$error && !$v.resource.body.required"
            class="label error pull-right"
            >Required</label
          >
          <template :class="{ error: $v.resource.body.$error }">
            <jodit-vue v-model="resource.body" :config="editorOptions" />
          </template>
        </div>
        <div class="col-xs-12 col-sm-6">
          <h2>Attributes</h2>
          <div class="row">
            <div class="col-xs-12">
              <label for="clients">Clients</label>
              <b-multi-select
                v-model="resource.clients"
                :options="clients"
                name="clients"
                class="multi-select"
                filterable
                block
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <label for="regions">Countries</label>
              <b-multi-select
                v-model="resource.regions"
                :options="regions"
                name="regions"
                class="multi-select"
                filterable
                block
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <label>Completion date</label>
              <p v-html="availableDateRange" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label
                v-if="
                  $v.resource.start_date.$error &&
                  !$v.resource.start_date.required
                "
                class="label error pull-right"
                >Required</label
              >
              <b-date-picker
                v-model="resource.start_date"
                :class="{ error: $v.resource.start_date.$error }"
              />
            </div>
          </div>
        </div>
      </div>
      .
      <div class="row">
        <div class="col-xs-12">
          <h2>Attachments</h2>
          <b-btn class="btn btn-success" @click="addFileRow">{{
            addAnotherFile
          }}</b-btn>
          <template
            v-for="(fileRowValue, fileRowIndex) in currentState.filesDetails"
          >
            <div class="row" :key="fileRowIndex">
              <br />
              <div class="col-xs-12 col-sm-4 col-lg-5">
                <template v-if="fileRowValue.key">
                  <h4>{{ fileRowValue.key }}</h4>
                </template>
                <template v-else>
                  <input
                    id="fileDetails"
                    name="fileDetails"
                    ref="files"
                    type="file"
                    class="form-control file"
                    placeholder="File name"
                    @change="handleFileUpload($event, fileRowIndex)"
                  />
                </template>
              </div>
              <div class="col-xs-12 col-sm-1 pull-right">
                <b-btn
                  class="btn btn-secondary"
                  @click="removeFileRow(fileRowIndex)"
                  >remove</b-btn
                >
              </div>
            </div>
          </template>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-xs-12">
          <div class="container center">
            <router-link to="/admin/projects">
              <b-btn class="btn-md btn-default">Cancel</b-btn>
            </router-link>
            &nbsp;&nbsp;&nbsp;
            <b-btn class="btn-md btn-primary" @click="saveRegulation"
              >Save</b-btn
            >
          </div>
        </div>
      </div>
      <br />
      <br />
    </section>
  </div>
</template>

<style lang="less" scoped>
.form-control {
  margin-bottom: 15px;
  border-radius: 4px !important;
}
.btn-primary {
  height: 40.25px;
}
textarea {
  resize: vertical;
}
.file {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.multi-select {
  margin-bottom: 15px;
}
.label {
  float: right;
}
.btn-lg {
  margin-right: 15px;
}
.error {
  border-color: red;
  color: red;
}
.multi-select-error {
  border: 1px red solid;
  border-radius: 4px;
}
.langInput {
  > section {
    min-height: 0px;
    margin: 0 auto;
    padding: 0px;
    text-align: left;
    > ul {
      margin: 0 auto;
      padding: 0px;
      text-align: left;
      > li {
        width: 100%;
        height: 100%;
        background-color: white;
        border: none;
        margin: 0 auto;
        padding: 0px;
        text-align: left;
      }
      > li:hover {
        width: 100%;
        height: 100%;
        background-color: white;
        border: none;
      }
    }
  }
}
.langListItem {
  text-align: left;
  background-color: white;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0 auto;
  padding: 5px 15px;
}
.langListItem:hover {
  background-color: #002d62;
  color: white;
  border-radius: 0px;
  border: none;
}
</style>

<script>
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { pullAt, map, flow } from 'lodash/fp';
import { Notification } from 'uiv';
import joditVue from 'jodit-vue';
import { mapGetters } from 'vuex';
import languages from 'language-list/data';
import languageList from 'language-list';
import { toFormData } from '@/modules/utils';

export default {
	components: { joditVue },
	created() {
		this.getCurrentState();
		this.getClients();
		this.getRegions();
		this.getTags();
		this.getStatus();
		this.getGroups();
	},
	data() {
		return {
			clients: [],
			tags: [],
			regions: [],
			status: [],
			groups: [],
			currentState: {
				title: null,
				reference: null,
				meta_description: null,
				body: '',
				clients: [],
				tags: [],
				regions: [],
				status: [],
				start_date: null,
				end_date: '',
				filesDetails: [],
			},
			files: [],
			editorOptions: {
				minHeight: 275,
			},
		};
	},
	validations: {
		resource: {
			title: { required },
			reference: {},
			body: { required },
			status: {},
			start_date: {
				isBeforeEndDate() {
					return this.validateDate.valid;
				},
			},
			end_date: {
				isAfterStartDate() {
					return this.validateDate.valid;
				},
			},
		},
	},
	computed: {
		addAnotherFile() {
			if (this.currentState.filesDetails.length > 0) {
				return '+ Add another file';
			}
			return '+ Add file';
		},
		formattedStartDate() {
			return this.resource.start_date
				? moment(this.resource.start_date).format('dddd DD MMM YYYY')
				: null;
		},
		formattedEndDate() {
			return this.resource.end_date
				? moment(this.resource.end_date).format('dddd DD MMM YYYY')
				: null;
		},
		validateDate() {
			/* eslint-disable-next-line */
      return { class: "label label-success", valid: true };
		},
		resource() {
			return this.currentState;
		},
		...mapGetters({ getBreadcrumbs: 'breadcrumbs' }),
		breadcrumbs() {
			return this.getBreadcrumbs;
		},
		availableLanguages() {
			return map(
				({ language, code }) => ({
					value: code,
					label: language,
				}),
				languages
			);
		},
		availableDateRange() {
			if (!this.resource.start_date) {
				return 'Please select a <label class="label label-danger">date</label>';
			}
			if (this.validateDate.valid) {
				return `
					<label class="label label-success">${this.formatStartDate()}</label>
				`;
			}
			return null;
		},
	},
	methods: {
		addFileRow() {
			this.currentState.filesDetails.push({ group: [], language: null });
		},
		removeFileRow(index) {
			this.currentState.filesDetails = pullAt(
				index,
				this.currentState.filesDetails
			);
			if (this.files[index]) {
				this.files = pullAt(index, this.files);
			}
		},
		formatStartDate() {
			const date = moment(this.resource.start_date).format('DD/MM/YYYY');

			if (date === 'Invalid date') {
				return 'In progress';
			}
			return `Completed: ${date}`;
		},
		async getCurrentState() {
			const { id } = this.$route.params;
			const {
				data: { data: currentState },
			} = await this.$axios.get(`/resource/${id}`);
			const state = flow(
				({
					clients,
					tags,
					files,
					status,
					regions,
					start_date: startDate,
					end_date: endDate,
					files: filesDetails,
					...rest
				}) => ({
					...rest,
					clients: map(client => client.id, clients),
					tags: map(tag => tag.id, tags),
					regions: map(region => region.id, regions),
					status: status.id !== 4 ? [status.id] : [],
					start_date: moment(startDate).format('YYYY-MM-DD'),
					end_date: moment(endDate).format('YYYY-MM-DD'),
					filesDetails: map(
						({ id: fileId, key, unbuiltKey, group, language }) => ({
							id: fileId,
							key: unbuiltKey || key,
							group: [group.id],
							language: languageList().getLanguageName(language),
						}),
						filesDetails
					),
				})
			)(currentState);
			this.$set(this, 'currentState', state);
		},
		async getClients() {
			const {
				data: { data },
			} = await this.$axios.get('/client');
			const clients = map(({ id, name }) => ({ value: id, label: name }), data);
			this.$set(this, 'clients', clients);
		},
		async getRegions() {
			const {
				data: { data },
			} = await this.$axios.get('/region');
			const regions = map(({ id, name }) => ({ value: id, label: name }), data);
			this.$set(this, 'regions', regions);
		},
		async getTags() {
			const {
				data: { data },
			} = await this.$axios.get('/tag');
			const tags = map(({ id, name }) => ({ value: id, label: name }), data);
			this.$set(this, 'tags', tags);
		},
		async getStatus() {
			const {
				data: { data },
			} = await this.$axios.get('/status');
			const filteredData = data.filter(d => d.id !== 4);
			const status = map(
				({ id, name }) => ({ value: id, label: name }),
				filteredData
			);
			this.$set(this, 'status', status);
		},
		async getGroups() {
			const {
				data: { data },
			} = await this.$axios.get('/group');
			const groups = map(({ id, name }) => ({ value: id, label: name }), data);
			this.$set(this, 'groups', groups);
		},
		async saveRegulation() {
			this.resource.status[0] = this.resource.status[0] !== undefined ? this.resource.status[0] : 4;

			const data = flow(
				({ status, ...rest }) => ({
					status_id: status[0],
					files: this.files,
					...rest,
				}),
				toFormData
			)(this.resource);

			if (this.$v.resource.$invalid) {
				this.$v.resource.$touch();
			} else {
				const { id } = this.$route.params;
				try {
					await this.$axios.put(`/resource/${id}`, data);
					this.$router.push({ path: '/admin/projects' });
					Notification.notify({
						type: 'success',
						title: 'Resource edited successfully.',
						duration: 10000,
					});
				} catch (e) {
					Notification.notify({
						type: 'danger',
						title: 'Could not edit resource.',
						content: e.response ? e.response.data.message : '',
						duration: 10000,
					});
				}
			}
		},
		handleFileUpload(
			{
				target: {
					files: [files],
				},
			},
			index
		) {
			this.files[index] = files;
		},
	},
};
</script>
